import nl from './nl'
import en from './en'
import tr from './tr'

export const LOCALES = ['nl', 'en', 'tr']

const STRINGS = { nl, en, tr }

const STORAGE_KEY = 'corendon_lang'

export function detectInitialLocale() {
  if (typeof window === 'undefined') return 'nl'
  // 1. URL param ?lang=tr always wins
  const params = new URLSearchParams(window.location.search)
  const fromUrl = params.get('lang')
  if (fromUrl && LOCALES.includes(fromUrl)) return fromUrl
  // 2. localStorage from a prior visit
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && LOCALES.includes(stored)) return stored
  } catch {
    // private mode — ignore
  }
  // 3. Always default to Dutch — visitor picks otherwise via the dropdown.
  return 'nl'
}

export function persistLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    /* ignore */
  }
}

export function t(locale, key, vars) {
  const dict = STRINGS[locale] || STRINGS.nl
  let s = dict[key] ?? STRINGS.nl[key] ?? key
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v))
    }
  }
  return s
}

// Per-locale first message used to override the agent's default when the
// visitor picks a non-Dutch language. NL is the agent's default so no
// override is needed; we include it for completeness so the override is
// always applied (cheap consistency, no edge cases).
export const FIRST_MESSAGE_BY_LOCALE = {
  nl: 'Hallo, welkom bij Corendon Service Reception. Hoe kan ik u vandaag helpen? U kunt vragen stellen over uw vlucht, een boeking wijzigen, of een bevestiging aanvragen.',
  en: "Hello, welcome to Corendon Service Reception. How can I help you today? You can ask about your flight, change a booking, or request a confirmation.",
  tr: 'Merhaba, Corendon Müşteri Hizmetlerine hoş geldiniz. Size bugün nasıl yardımcı olabilirim? Uçuşunuzla ilgili soru sorabilir, rezervasyonunuzu değiştirebilir veya onay isteyebilirsiniz.',
}
